CT.localityObject={data:[]};
CT.areaVal = "";
CT.shortListHotels= {};
CT.utils.trackers.eventData = {};
CT.utils.trackers.eventData.pageLoadStartTime = Date.now();
!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/index',[/*'libs/ct_user', */'libs/ct_pers', 'libs/ct_store', 'libs/ct_routes', 'hotels/session', 'hotels/searchForm', 'hotels/recentSearch', 'hotels/recentViewed' ,'common/searchTab', 'common/smartHomePage',  'widgets/ct_offermgmt', 'hotels/validators', 'widgets/tooltip_v2','common/currencyConverter', 'common/utils', 'hotels/hotel_utils', 'widgets/placeholder' , 'libs/local_homepage'], module)
		else
	//>>excludeEnd("requireTmpl");
module(/*CT.User, */CT.Pers, CT.Store, CT.Routes, CT.Session, CT.cache.views.searchForm, CT.cache.views.recentSearch, CT.cache.views.recentViewed, CT.cache.views.searchTab,  CT.smartHomePage, CT.Offers, CT.settings.validators)
}(function(/*User, */Pers, store, Routes, Session, searchFormView, recentSearchView, recentViewedView ,searchTabView, smartHomePageView, Offers, FormValidator, modifySearchFormView){

	if(window.serverCurrentDate && typeof(window.serverCurrentDate)){
		window.ctCurrentDate = window.serverCurrentDate.getDate() + "/" + parseInt(window.serverCurrentDate.getMonth() + 1) + "/" + window.serverCurrentDate.getFullYear();
	}

	/* ======================= MODULE SPECIFIC VARIABLES  =========================== */
	var routes
	
	/* ======================= PRIVATE METHODS =========================== */
	function setMouseFlowPage(url){
		if(typeof mouseflow !== 'undefined'){
			var mouseflowPath = url;
			mouseflow.newPageView(mouseflowPath);
		}
	}


	function showPersInfo(res){
		var pers = this
		var tmp, tmp1

		// display last search
		searchFormView.fire('searchForm.update', [pers]);
		if(window.enableRecentSearch){
			if(($.browser.msie && parseInt($.browser.version, 10) <= 8)) {
			} else {
				// populate recent search
				var recentPers = pers.get('recent');
				if(recentPers)
					recentSearchView.render(recentPers);
				else
					recentSearchView.hideRecent();
			}


			//HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK
			if(window.location.search.indexOf('ui=v3') >= 0) {
				_.each($('#RecentSearch li a'), function(anchorTag) {
					tmp = $(anchorTag);
					tmp1 = tmp.attr('href');
					if(tmp1.indexOf('ui=v3') < 0)
						tmp.attr('href', tmp1 + '&ui=v3');
				});
			}
			//HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK-HACK
		}

		Session.lastDroppedBook(pers);


		// get user obj	
		/*var user = User.getInstance()

		if (user.isLoggedIn) {
			//Session.smartness(pers);
			Session.lastDroppedBook(pers);
		} else {
			//Repeat confirmed user - not loyal
			//TODO: need to check for few cookies before display - karthik
			//Session.welcomeBack(pers);
		}*/
	}

	/*========== Recent Viewed Hotels============*/

	function showRecentHotelViewed(){
		recentViewedView.render();
	}

	/*===============Smart Home Page start================*/
	function showSmartHomePage(){
		smartHomePageView.render();
	}

	/*===============Smart Home Page End================*/


	//debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
	var runAjax = function(url, data) {
		return $.ajax({url : url, type : 'GET', data : _.serialize(data)});
	}

	function checkValidUser(){
		var _ctAuth = CT.utils.readCTAuthCookie()
		, _userId = CT.utils.cookies.read('userid');
		CT.showDebug ? '' : CT.showDebug = false;

		if(_ctAuth && _userId && _userId.indexOf('cleartrip.com') >= 0 && CT.showDebug == false){
			//runAjax('/hotels/service/debug-view?userName='+_userId)
			runAjax('/hotels/debug-view')
			.done(function(response) {
				var resObj = eval('('+response+')')
				if(resObj.status === 1) $('.searchBtnContainer').append('<p class="fLeft"><label  for="showDebug" ><input type="checkbox" value="true" name="showDebug" id="showDebug"> Show debug mode</label></p>');
				CT.showDebug = true;
			}).fail(function (err){

			})
		}
	}
	//debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA




	function getPathName(urlData){
		var loc = window.location,url;
		if(CT.subProd && CT.subProd =="wg"){
			if(($.browser.msie && parseInt($.browser.version, 10) <= 9)) {
				url =  loc.protocol + '//' + loc.hostname +(window.CT.langUrlPrefix? window.CT.langUrlPrefix:"")+ "/hotels/results?"
			}else{
				url =  loc.protocol + '//' + loc.hostname +(window.CT.langUrlPrefix? window.CT.langUrlPrefix:"")+ "/getaways/results?"
			}
		}else{
			url =  loc.protocol + '//' + loc.hostname +(window.CT.langUrlPrefix? window.CT.langUrlPrefix:"")+ "/hotels/results?"
		}
		//TODO add check for international later
		return url;

	}

	// This sets up the personalization when the home page loads
	function initPers(){
		//TODO: remove comment to enable personalization : karthik
		var pers = new Pers(); // creates a new Pers table for a new user
		showPersInfo.call(pers)
		Offers.init({product : 'hotel', page : 'home', url : homePageOffersJson});
		$(".tipsy").hide();
	}




	function checkGclId(pageType){
		if(pageType){
			var urlObj = _.deserialize(window.location.search.substring(1));
			if(urlObj.gclid){
				CT.utils.cookies.create("utm_source","googlesem",1/48);
				var routes = "";
				if(pageType == "home"){
					urlObj.utm_source ="googlesem";
					routes = "?";
					CT.settings.routes.navigate(routes + _.serialize(urlObj), {
		                trigger: false,
		                replace: true
		           	});
				}
			}
		}
	}
	function getShortlistsCount(){
		var isLoggedIn = CT.utils.readCTAuthCookie();
		if(isLoggedIn){
			runAjax('/hotels/slapi/shortlist/fetch?oc=true')
			.done(function(response) {
				var shortlistsCount = parseInt(response.shortlistCount);
				if(shortlistsCount >= 1){
					CT.shortListHotels.total = response.shortlistCount;
					$('.shortlistLink').show();
					if(shortlistsCount > 1){
						var shortlistLinkText = "View your shortlists";
						$('.shortlistLink__text').html(shortlistLinkText);															
					}
					$('.shortlistLink__count').html('<span>'+ shortlistsCount +'</span>');
				} 
			}).fail(function (err){

			})
		}
	}

	// This initializes the app when the home page loads
	function init(e){
		//Sync shortlisted hotel on UI
		window.CT.utils.shortlists.sync();
		if(CT.app === "shortlist"){
			return false;
		}
		var paramsHash = {};
		//GA Tag Manager Object
		dataLayer = CT.settings.GATagManager;
		dataLayer[0]['Date-Search']	= moment().format("DD/MM/YYYY");
		dataLayer[0]['Day-Search']		= moment().format("dddd");
		dataLayer[0]['Product'] = "Hotel";
		dataLayer[0]['Device']="Desktop";


		CT.utils.modifySearch.close();
		CT.utils.modifySearch.closeLabel();
		searchFormView.render();

		if($.isReady)
			initPers()
		else
			$(initPers)

		//update markup classes based on url params
		CT.utils.helperFunctions.setUrlParamsInView(paramsHash);
		
		//TODO: remove comment to enable personalization : karthik
		//var user = User.getInstance()
		//if(user.loggedIn) //TODO enable this in production
		//	if(!e)
				//initPers(e)
				$("body").removeClass("srp").addClass("home");
				/*if(window.enableBannerAutomation){
					CT.utils.helperFunctions.displayBanners({"page":"home","url":window.homePageBannersJson});
				}else{
					$('#homeUpsellBanner').show();
				}*/
				setMouseFlowPage('/hotels')
				checkValidUser();
				if(window.isShortListEnabled){
					getShortlistsCount();				
				}
				checkGclId("home");
				CT.utils.helperFunctions.spotNonCleartripReferrer(undefined,window.location.href);

				if($.isLoaded){
					CT.utils.loadTrackers();
				}else{
					$(window).load(CT.utils.loadTrackers);
				}

				showSmartHomePage();
				showRecentHotelViewed();
				//Set user location data
				//CT.utils.helperFunctions.setUserHomeCity();
				dataLayer[0]['From-Location'] = 'Value';
				dataLayer[0]['People-No'] = 'Value';
				dataLayer[0]['To-Location'] = 'Value';
				dataLayer[0]['Travel-Dates'] = 'Value';
				dataLayer[0]['People-No']='Value';
				dataLayer[0]['Rooms-No']='Value';
				dataLayer[0]['Travel-Type']='Value';
				CT.utils.helperFunctions.includeGATagManager();
				if(window.enableLocalTab && window.localsHome){
					window.localsHome.initv2({attachLink:true , localsLinkId:"localsNav"})
				}
				CT.utils.helperFunctions.inspectLetJsForHotels();
				CT.utils.helperFunctions.storeUserReferer();
			}

	// This lazy loads the results page
	function _loadResultsPage(paramsHash){ // paramsHash contains all the URL params + routes data
			//>>excludeStart("asyncRequireLoader", pragmas.asyncRequireLoader);
			if(window.define)
				require(['hotels/searchResult'], function(){
					CT.cache.resReady = true
					CT.fire('results', [paramsHash])
				})
			else
			//>>excludeEnd("asyncRequireLoader");
		if(!$.isReady)
					$(function(){ //fires when DOM is ready
						CT.fire('results', [paramsHash]);
					})
				else
					CT.fire('results', [paramsHash]);
			}


	// This lazy loads the results page
	function loadResultsPage(paramsHash){ // paramsHash contains all the URL params + routes data
		if((paramsHash.from != undefined && paramsHash.from != "") && ('city' in paramsHash && paramsHash.city.length < 1)){
			var f = FormValidator.checkForCityAvailability
			$.when(f(paramsHash.from)).done(function(a1){
				/* Example a1[0] json
				 * { "st":"1",
					 "r":[
					{"ty":"c", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "z":"554", "tp":"1"},
					{"ty":"a", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"Koramangala", "z":"56", "tp":"1"},
					{"ty":"a", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"MG Road", "z":"53", "tp":"1"},
					{"ty":"a", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"Indiranagar", "z":"35", "tp":"1"},
					{"ty":"a", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"City Centre-Near MG Road", "z":"33", "tp":"1"},
					{"ty":"a", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"Gandhi Nagar", "z":"31", "tp":"1"},
					{"ty":"c", "k":"143306", "s":"NSW", "c":"AU", "cy":"Bangalow", "sc":"New South Wales, Australia", "z":"1"},
					{"ty":"p", "k":"32550", "s":"Karnataka", "c":"IN", "cy":"Bangalore", "sc":"Karnataka, India", "n":"Bangalore Palace", "z":"85"},
					{"ty":"a", "k":"35284", "s":"Karnataka", "c":"IN", "cy":"Mysore", "sc":"Karnataka, India", "n":"Bangalore-Nilgiri Road", "z":"5"},
					{"ty":"a", "k":"35284", "s":"Karnataka", "c":"IN", "cy":"Mysore", "sc":"Karnataka, India", "n":"Bangalore Highway", "z":"3"}
					]}
					*/
					var cityData = a1.r[0]
					paramsHash.city = cityData.cy
					paramsHash.state = cityData.s
					paramsHash.country = cityData.c
				//debugger;
				routes.navigate(window.location.href.replace(/city=[^&.]*&/, 'city=' + paramsHash.city + '&').replace(/state=[^&.]*&/, 'state=' + paramsHash.state + '&').replace(/country=[^&.]*&/, 'country=' + paramsHash.country + '&'), {trigger : false, replace : true})
				_loadResultsPage(paramsHash)
			}) 
		} else _loadResultsPage(paramsHash)
	}
	

	//Construct the url for trip advisor..Need to be removed once a/b testing is done
	function urlToObject(url){
		var searchString = url.substring(1),
		params = searchString.split("&"),
		hash = {};
		for (var i = 0; i < params.length; i++) {
			var val = params[i].split("=");
			hash[unescape(val[0])] = unescape(val[1]);
		}
		return hash;
	}





	// This opens search result page
	function showSearchResultPage(data){ // When called directly from address bar, data will be undefined
		var routesData = data, paramsHash;
		if(window.location.hostname =="www.cleartrip.com"){
			CT.utils.helperFunctions.inspectForGoogleAnalatics()
		}
		//start - couting srp render timing.
		CT.settings.srpRenderTime = new Date().getTime();
		
		/*Following If check is for specific use case where user is coming from tripAdvisor or Hotel directory pages
			In this case when user lands and SRP and then does a browser back there were js errors due to the url being different,
			so making one more level of history back.
			*/

			if(routesData && routesData.isPopped && routesData.isPopped == true && (window.location.search.indexOf("ckIn") != -1 || window.location.search.indexOf("ckOut") != -1)){
				window.history.back();
			}
			//paramsHash = _.deserialize(window.location.href.split('results?')[1], ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
			paramsHash = _.deserialize(window.location.search.substr(1), ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
			

		$('#Home').css('display', 'none'); // hide home
		$('#HomeLongForm').css('display', 'none'); // hide home
		$(".city_seo_content").hide();
		$('#homeUpsellBanner').hide();	
		if(paramsHash.from && paramsHash.city){
			delete paramsHash.from;
		}
		if(paramsHash.from){
			CT.subProd = "wg";
			if(window.isMobileUA && window.isMobileUA == true){
				window.altFilters = "false"
				$(".primaryFilter").hide();
				//$("#distanceFilter").show();
			}
			if(($.browser.msie && parseInt($.browser.version, 10) <= 9)) {
				window.altFilters = "false"
				$(".primaryFilter").hide();
				$("body").removeClass("home").addClass("weekend srp");
				$("body").removeClass("optiond")
				//$("#distanceFilter").show();
			}else{
				window.altFilters = "true"
				$("body").removeClass("home").addClass("weekend optiond srp");
				$(".primaryFilter").show();
			}
			CT.utils.cookies.create("hotelTripType","outsideCity",365);
		}else{
			window.altFilters = "false"
			$(".primaryFilter").hide();
			$('body').removeClass("weekend optiond");
			$(".globalFooter").show()
			CT.utils.cookies.create("hotelTripType","withinCity",365);
		}
		
		$('#Result').css('display', 'block'); // show result section
		//initializes placeholder for modify search form in results page
		//modifySearchFormView.render();

		function newSearchFlow(paramsHash){
			var tabCheckParams = ['city', 'chk_in', 'chk_out', 'country', 'state']
			CT.fire('tab.init', [paramsHash, tabCheckParams]); // create a new tab
			loadResultsPage(paramsHash);
		}

		function existingSearchFlow(paramsHash){
			//debugger;
			//$('#ResultContainer_'+CT.settings.currentTab).hide(); // hide current result container

			var tabId = searchTabView.getCurrentTab(paramsHash).tabId || ""; // get the tab id of the requested tab
			var tmp;

			//compare(paramsHash, CT.cache.tabsMap[tabId])

			if($('#ResultContainer_' + tabId)[0]){ // if the container is present , do a toggle for those tabs.
				$('#ResultContainer_'+CT.settings.currentTab).hide();
				$('#ResultContainer_' + tabId).show();
				$('#RecentTab_' + tabId.split('_')[0]).siblings().removeClass('current').end().addClass('current');
				CT.settings.currentTab = tabId;
				$('#SearchBtn').removeClass('loading');

				CT.utils.modifySearch.close();
				CT.utils.modifySearch.openLabel(CT.cache[CT.settings.currentTab].searchParams.processed);
			} else {	// if the container isnt present , call newSearchFlow
				newSearchFlow(paramsHash);
			}
			CT.utils.helperFunctions.setUrlParamsInView(paramsHash);
		}


		try{
			checkGclId("srp");
			//paramsHash = _.deserialize(window.location.href.split('results?')[1], ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
			/*if(window.hotelTwoCol == true){
				var twoColChk = CT.utils.getAbTestCookie("hotels_two_col");
				//var twoColChk = window.ab_two_col_layout?"b":null;
				if(twoColChk && twoColChk == "b"){ 
					window.twoCol = true;
					$('body').addClass("bTest");
				}else if(window.hotelTwoColTest == true && twoColChk == null){
					window.twoCol = true;
					$('body').addClass("bTest");
				}
			}*/
			/*if(window.product != "B2B" && window.enableHotelModalV2){
				//var modalV2AbTest = CT.utils.getAbTestCookie("hotels_modalv2");
				var modalV2AbTest = window.overrideHotelModalV2Ab;
				if(modalV2AbTest == null){ //for testing
					modalV2AbTest = window.overrideHotelModalV2Ab;
				}
				if(modalV2AbTest && modalV2AbTest == "b"){
					window.hotelModalV2 = false;
				}else{
					window.hotelModalV2 = true;
				}
			}*/
			
			//For preventing new stp flow for B2B and non in domain and for A/B testing (removed A/B testing for STP)
			if(window.enableNewStpFlow){
				if(window.product == "B2B" || window.countryCode != "in"){
					window.enableNewStpFlow = false;
				}
			}
			//Set user location data
			// CT.utils.helperFunctions.setUserHomeCity();
			// Enable hotel details page for all search - ASC-312
			window.hotelModalV2 = true;
			// if(window.product != "B2B"){
			// 	if(paramsHash.country && paramsHash.country.toLowerCase() != "in"){
			// 		var modalV2AbIntlTest = CT.utils.getAbTestCookie("hotels_modalv2_intl");
			// 		if(modalV2AbIntlTest == null){ //for testing
			// 			modalV2AbIntlTest = "a";
			// 		}
			// 		if(modalV2AbIntlTest && modalV2AbIntlTest == "b"){
			// 			window.hotelModalV2 = true;
			// 		}else{
			// 			window.hotelModalV2 = false;
			// 		}
			// 	}else{
			// 		window.hotelModalV2 = true;
			// 	}
			// }
			if(window.hotelTwoCol == true){
				var twoColChk = CT.utils.getAbTestCookie("hotels_two_col_layout");
				//var twoColChk = window.ab_two_col_layout?"b":null;
				/*if(twoColChk){ 
					 window.abTestVal = twoColChk;
				}else if(twoColChk == null && window.hotelTwoColLayoutTest == true){
					window.abTestVal = window.hotelTwoColVarient;
				}else{
					window.abTestVal = window.hotelTwoColVarient;
				}*/
				window.abTestVal = "b"
			}
			if(window.product != "B2B" && window.countryCode == 'in'){
				if(paramsHash.city && window.budgetBadgeFilter.cities.indexOf(paramsHash.city) != -1){
					var budgetBadgeAB = CT.utils.getAbTestCookie("hotels_budget_badge");
					if(!budgetBadgeAB){
						window.budgetBadgeABVal = window.budgetBadgeFilter.defaultVal;
					}else{
						window.budgetBadgeABVal = budgetBadgeAB;
					}
				}else{
					window.budgetBadgeABVal = "a";
				}
				

			}else{
				window.budgetBadgeABVal = "a";
			}
			//Read Cookie for chunky filters.Enable when its b
			//Enable new filters for all products
			window.chunkyFiltersEnabled = true;
			if(paramsHash.city && window.staticImgDomainProp.cities.indexOf(paramsHash.city) != -1){
				window.hotelBaseLink = window.staticImgDomain;
			}
			
			
			/*if(window.product != "B2B" && window.countryCode == 'in'){
				if(paramsHash.city && window.taxExclusiveCities_A.indexOf(paramsHash.city) != -1){
					var taxExclAbTest_A = CT.utils.getAbTestCookie('tax_exclusive_ab_test_blr');
					if(!taxExclAbTest_A){
						taxExclAbTest_A = window.tax_exclusive_ab_test_A;
					}
					if(taxExclAbTest_A == "b"){
						window.taxAbTest_A = 'b';
					}
				}else{
					window.taxAbTest_A = 'a';
				}
			}*/
			if(window.product == "B2B"){
				window.taxAbTest = 'b'
			}
			
			//GA Tag Manager Object
			dataLayer = CT.settings.GATagManager;
			dataLayer[0]['To-Location']	= paramsHash.city;
			dataLayer[0]['Travel-Type']	= 'Hotels';
			if(CT.subProd=="wg"){
				dataLayer[0]['From-Location']	= paramsHash.from;
				dataLayer[0]['To-Location']	= 'Value';
				dataLayer[0]['Travel-Type']	= 'Getaways';
			}
			dataLayer[0]['Travel-Dates']= paramsHash.chk_in+'|'+paramsHash.chk_out;
			dataLayer[0]['Rooms-No']	= paramsHash.num_rooms;
			dataLayer[0]['Date-Search']	= moment().format("DD/MM/YYYY");
			dataLayer[0]['Day-Search']	= moment().format("dddd");
			dataLayer[0]['Product'] = "Hotel";
			dataLayer[0]['Device']="Desktop";

			if(!routesData || (routesData && !routesData.isPopped)){ // if flow is from direct url search or if flow is from search form
			//	&& (!$.browser.msie || !parseInt($.browser.version, 10) <= 9)
				//Check for tripadvisor url
				if(window.location.search.indexOf("utm_source") == -1){
						CT.utils.cookies.erase('metaPah');
				}
				if(!routesData){
					var tmpParamsObj = $.extend({}, paramsHash)
					if(paramsHash.from && paramsHash.city && window.location.search.indexOf("utm_source") == -1){
						//$("#hotelsViewSwitcher").show();
						//var tmpParamsObj = $.extend({}, paramsHash)
						delete tmpParamsObj.from;
						CT.utils.cookies.create("hotelTripType","withinCity",365);
						var tmpNewUrl = _.serialize(tmpParamsObj);
						if((tmp = CT.settings.routes.checkUrlForIE(getPathName() + tmpNewUrl)).toReplace) { // for IE with hashchange supported browser
							window.location.href = tmp.tmpNewUrl;
							return;
						}
						else {
							return CT.settings.routes.navigate(getPathName() + tmpNewUrl)
						}
					}
					if(paramsHash.from && paramsHash.city && window.location.search.indexOf("utm_source") != -1){
						delete paramsHash.from;
					}
					
					
					
					if(paramsHash.airBnb == "true"){
						CT.subProd = "airBnb";
						$('body').addClass("airBnb");
						CT.utils.cookies.create("hotelTripType","airBnb",365);
					}else{
						$('body').removeClass("airBnb");
					}
					CT.utils.showActiveCurrMenu();
					var paramsObj = $.extend({}, paramsHash)
					if(window.location.search.indexOf("gn") != -1 && paramsObj.gn && paramsObj.gn === true){
						//var paramsObj = urlToObject(window.location.search)
						delete paramsObj.gn;
						for (var k in paramsObj) {
							if(_.contains(CT.settings[CT.app].filterParamList, k) == true){
								delete paramsObj[k]; 
							}

						}
						var newUrl = _.serialize(paramsObj)
						if((tmp = CT.settings.routes.checkUrlForIE(getPathName() + newUrl)).toReplace) { // for IE with hashchange supported browser
							window.location.href = tmp.newUrl;
							return;
						}
						else {
							return CT.settings.routes.navigate(getPathName() + newUrl)
						}
					}
					
					if(window.location.search.indexOf("utm_source") != -1){
						//var urlHash = urlToObject(window.location.search)
						//var urlParams=CT.utils.helperFunctions.queryToObj(window.location.search)
						
						var urlHash = _.deserialize(window.location.href.split('results?')[1], ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
						CT.utils.cookies.create("utm_source",urlHash.utm_source,1/24);
						if(window.location.search.indexOf("ckOut") != -1 || window.location.search.indexOf("chk_out") != -1){
							if(urlHash.ct_hotelid != undefined && urlHash.ct_hotelid != "" && urlHash.utm_source != ""){
							 CT.utils.cookies.create("metaPah",urlHash.utm_source)
								if(window.hotelModalV2){
									CT.utils.cookies.create("hotelTripType","withinCity",365);
									if(window.location.search.indexOf("chk_out") != -1){
										var urlData = urlHash;
									}else if(window.location.search.indexOf("ckin") != -1){
										urlHash.chk_in = urlHash.ckin;
										urlHash.chk_out = urlHash.ckOut;
										var urlData = urlHash;
									}else{
										var newUrl = "city=&state=&country="+urlHash.country+"&area=&poi=&hotelName=&dest_code=&chk_in="+urlHash.ckIn+"&chk_out="+urlHash.ckOut+"&adults1="+urlHash.ad+"&children1="+urlHash.cd+"&num_rooms="+urlHash.noOfRooms+"&utm_source="+urlHash.utm_source+"&utm_medium="+urlHash.utm_medium+"&ct_hotelid="+urlHash.ct_hotelid+"&utm_campaign="+urlHash.utm_campaign+"&utm_content="+urlHash.utm_content+"&utm_term="+urlHash.utm_term+"&ref="+urlHash.refid+"";
										//var urlData = urlToObject(newUrl);
										var urlData = _.deserialize(newUrl, ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
										if(urlHash.utm_source == "Trivago"){
											for(var k=1;k<=urlHash.noOfRooms;k++){
												urlData["adults"+k] = urlHash["ad"+k]
												urlData["children"+k] = urlHash["cd"+k]
											}
										}
									}
									if(!window.spotNonCleartripReferrer_onResultPage){
										CT.utils.helperFunctions.spotNonCleartripReferrer(undefined,window.location.href);
										window.spotNonCleartripReferrer_onResultPage = true;
									}
									if(CT.utils.helperFunctions.paidChannelTracker) {
										CT.utils.helperFunctions.paidChannelTracker(_.deserialize(window.location.href.split('results?')[1]));
									}
									var modifiedSearchObj = CT.utils.helperFunctions.basicSearchParams(urlData);
									var hotelModelURL = CT.utils.helperFunctions.openHotelModalV2(urlHash.ct_hotelid ,modifiedSearchObj,"#");
									window.location.href =  "http:" + '//' + window.location.hostname + hotelModelURL
									return;
								}else if(window.location.search.indexOf("ckin") != -1){
									CT.utils.cookies.create("hotelTripType","withinCity",365);
									urlHash.chk_in = urlHash.ckin;
									urlHash.chk_out = urlHash.ckOut;
									//var newUrl = "city=&state=&country="+urlHash.country+"&area=&poi=&hotelName=&dest_code=&chk_in="+urlHash.ckin+"&chk_out="+urlHash.ckOut+"&adults1="+urlHash.ad+"&children1="+urlHash.cd+"&num_rooms="+urlHash.noOfRooms+"&utm_source="+urlHash.utm_source+"&utm_medium="+urlHash.utm_medium+"&ct_hotelid="+urlHash.ct_hotelid+"&utm_campaign="+urlHash.utm_campaign+"&utm_content="+urlHash.utm_content+"&utm_term="+urlHash.utm_term+"&ref="+urlHash.refid+"";
									var newUrl = _.serialize(urlHash);
									if((tmp = CT.settings.routes.checkUrlForIE('/hotels' + getPathName() + newUrl)).toReplace) { // for IE with hashchange supported browser
										window.location.href = tmp.newUrl;
										return;
									}
									else {
										return CT.settings.routes.navigate(getPathName() + newUrl)
									}
									
								}else if(window.location.search.indexOf("chk_out") != -1){
									CT.utils.cookies.create("hotelTripType","withinCity",365);
									var tmpNewUrl = _.serialize(tmpParamsObj);
									if((tmp = CT.settings.routes.checkUrlForIE('/hotels' + getPathName() + tmpNewUrl)).toReplace) { // for IE with hashchange supported browser
										window.location.href = tmp.tmpNewUrl;
										return;
									}
									else {
										return CT.settings.routes.navigate(getPathName() + tmpNewUrl)
									}
								}else{
									var newUrl = "city=&state=&country="+urlHash.country+"&area=&poi=&hotelName=&dest_code=&chk_in="+urlHash.ckIn+"&chk_out="+urlHash.ckOut+"&adults1="+urlHash.ad+"&children1="+urlHash.cd+"&num_rooms="+urlHash.noOfRooms+"&utm_source="+urlHash.utm_source+"&utm_medium="+urlHash.utm_medium+"&ct_hotelid="+urlHash.ct_hotelid+"&utm_campaign="+urlHash.utm_campaign+"&utm_content="+urlHash.utm_content+"&utm_term="+urlHash.utm_term+"&ref="+urlHash.refid+"";
									var urlData = _.deserialize(newUrl, ['area', 'poi','ca1','ca2','ca3','ca4','ca5','ca6'])
									if(urlHash.utm_source == "Trivago"){
										for(var k=1;k<=urlHash.noOfRooms;k++){
											urlData["adults"+k] = urlHash["ad"+k]
											urlData["children"+k] = urlHash["cd"+k]
										}
									}
									var tmpUrl = _.serialize(urlData);
									if((tmp = CT.settings.routes.checkUrlForIE('/hotels' + getPathName() + tmpUrl)).toReplace) { // for IE with hashchange supported browser
										window.location.href = tmp.tmpUrl;
										return;
									}
									else {
										return CT.settings.routes.navigate(getPathName() + tmpUrl)
									}
								}
							}
						}
					}
					if(window.location.search.indexOf("ckIn") != -1 && window.location.search.indexOf("ckOut") != -1){
						var urlHash = urlToObject(window.location.search)
						var tmp= '';
						for(var i=1;i<=urlHash.noOfRooms;i++){
							tmp += "&adults"+i+"="+urlHash.ad.split(",")[i-1]+"&children"+i+"="+urlHash.cd.split(",")[i-1]
							var cdArray = "ca"+i
							if(urlHash[cdArray]){
								var childAgeArr = urlHash[cdArray].split(",")
								for(var j=0;j< childAgeArr.length;j++){
									if(childAgeArr[j] != '') tmp += "&ca"+i+"="+childAgeArr[j]
								}
						}
					}
					var newUrlHash = {"city":urlHash.city?urlHash.city:'',"state":urlHash.state?urlHash.state:'',
					"country":urlHash.country?urlHash.country:'',"org":urlHash.org?urlHash.org:'',"hotelId":urlHash.ct_hotelid?urlHash.ct_hotelid:'',"area":urlHash.areasDropdown?urlHash.areasDropdown:'', "payAtHotel":(urlHash.payAtHotel || ""), 'quickey': urlHash.quickey, 'propertyType': urlHash.propertyType}
					var newUrl = "city="+newUrlHash.city+"&state="+newUrlHash.state+"&country="+newUrlHash.country+"&area="+newUrlHash.area+"&poi=&hotelName=&chk_in="+urlHash.ckIn+"&chk_out="+urlHash.ckOut+"&org="+newUrlHash.org+"&num_rooms="+urlHash.noOfRooms+"&ct_hotelid="+newUrlHash.hotelId+tmp + ((newUrlHash.payAtHotel)?("&payAtHotel="+newUrlHash.payAtHotel):"") + (newUrlHash.quickey ? '&quickey=true': '') + ((newUrlHash.propertyType != undefined) ? ("&propertyType=" + newUrlHash.propertyType) : "");

						if((tmp = CT.settings.routes.checkUrlForIE(getPathName() + newUrl)).toReplace) { // for IE with hashchange supported browser
							window.location.href = tmp.newUrl;
							return;
						}
						else {
							return CT.settings.routes.navigate(getPathName() + newUrl)
						}
					}

					if((tmp = CT.settings.routes.checkUrlForIE()).toReplace) { // for IE with hashchange supported browser
						window.location.href = tmp.newUrl;
						return;
					}

				}
				newSearchFlow(paramsHash);
			}else{ // if the flow is from browser history
				existingSearchFlow(paramsHash);
			}
			
			CT.utils.helperFunctions.storeUserReferer();
		} catch(e) {
			// handle error cases where parameters are mismatching. (status-400)
		}
	}



	/* 	=================== Adding subscriptions  =================== */
	CT.subscribe('results.old', function(data, tabId){
		var params = !data.url? _.serialize(data) : data.url
		CT.settings.routes.navigate(getPathName(data) + params, {trigger : false})
		$('.resultContainer').hide()
		$('#ResultContainer_' + tabId).show();// show hide the results container
		setMouseFlowPage(getPathName(data) + params)
	})

	CT.subscribe('url.update', function(data){
		var routes = CT.settings.routes
		if(CT.subProd == "wg" && data.from == ""){
			data.from = data.city;
		}
		if(CT.subProd == "airBnb" && data.trip_type == "airBnb"){
			data.airBnb = true;
			data.num_rooms=1;
			data.children1=0;
		}
		var urlData = CT.subProd != "wg" ? routes.cleanURLParams($.extend({}, data),CT.settings[CT.app].cleanUrlParams) : routes.cleanURLParams($.extend({}, data),CT.settings[CT.app][CT.subProd].cleanUrlParams)
		var url = _.serialize(urlData), tmp
		
		if(urlData.hotelId != undefined && urlData.hotelId != "" && CT.subProd !== "wg"){
			urlData["hotelNameSearch"]=true;
			var modifiedSearchObj = CT.utils.helperFunctions.basicSearchParams(urlData);
			var hotelModelURL = CT.utils.helperFunctions.openHotelModalV2(urlData.hotelId ,modifiedSearchObj,"#");
			window.location.href =  "http:" + '//' + window.location.hostname + hotelModelURL
		}else{
			 if(($.browser.msie && parseInt($.browser.version, 10) <= 9)) { // For IE-7 and 8 reload the results page
			 	if(CT.subProd && CT.subProd =="wg"){
			 		var routesPath = '/hotels';
			 		var routes = (CT.settings.routes = new Routes(routesPath).add({
						'': ['home', init], //TODO enable in production
						'/?:params': ['home', init], //TODO enable in production
						'ui=v3': ['home', init], //TODO enable in production

						'/results?:params' : ['search', showSearchResultPage]

					}))
			 	}
			 	var loc = window.location
			 	var _url = getPathName(urlData) + url
			 	_url = routes.__fix(routes.getPathname(_url))
			 	if(window.location.href == _url){
			 		window.location.reload()
			 	}else{
			 		window.location.assign(_url);
			 	}
			 } else {
			 	if($.browser.msie && $.browser.version == "9.0" 
			 		&& window.location.hash == unescape("#"+ getPathName(urlData) + url)){
						window.location.reload(); //if the modify search params are same as the browser url params , the hash change will not get triggered for IE 9, so we are manually reload the page 
				}else if(navigator.userAgent.indexOf("iPad") != -1){
					var loc = window.location
					window.location.href =  getPathName(urlData) + url 
				}else{
					return routes.navigate(getPathName(urlData) + url, data)
				}

			}
		}
		
		
	})


	/*==================================  APP SPECIFIC UTILS  =====================================*/





	/* =================== Module execution starts here  =================== */
  	//set the viewController min-height based on viewport height
 
  	var asideLeftHeight = $('#Home').find('aside').first().outerHeight(),
  	asideRightHeight = $('#Home').find('aside').last().outerHeight(),
  	windowHeight = $(window).outerHeight(),
  	appBannerHeight = $('#homeUpsellBanner').outerHeight(),
  	bottom_val = $('.globalFooter').outerHeight() + $('.globalFooter').offset().top,
  	appBannerHeight = appBannerHeight?appBannerHeight:'0';

  	var height = Math.max(asideLeftHeight, asideRightHeight)//, windowHeight - 102 - appBannerHeight + bottom_val);

  	$('.viewController').css('min-height', height + 'px');


  	CT.cache.els = {
  		$homeSection : $("#Home"),
  		$homeCenter : $('#Home .viewController'),
  		$resultSection : $("#Result")
  	};

	//TODO: move this delegate call to a common app place.
	CT.widgets.validator.delegate({errContainer:"fieldset"});

	 //initalize more option link
	 $("#moreProductsLink").bind("click", function(e) {
	 	$(".moreProducts").toggle();
	 });

	 $(document).delegate('#srpHeaderLabel',"click",function(){
	 	$("#modifySearchLink").trigger("click");
	 	var now =  new Date().getTime();
	 	var start = CT.utils.trackers.eventData && CT.utils.trackers.eventData.userSessionStart  ? CT.utils.trackers.eventData.userSessionStart : now;
	 	var timeSpent = (now - start)/1000 // converting in seconds;

	 	var isGooglLocationSelected = false, areaSearch = "";
 	 	if( CT.cache[CT.settings.currentTab].googleSortedPoi ){
 	 		isGooglLocationSelected = true;
 	 		areaSearch = CT.cache[CT.settings.currentTab].googleSortedPoi[0];
 	 	}
	 	CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_Date_Click',{
            "timeSpent" : timeSpent,
            "isLocFltEn" : isGooglLocationSelected,
            "POI" : areaSearch
        });
	 })
	 $(document).delegate("#modifySearchLink","click",function(e){

	 	var tabCache = CT.cache[CT.settings.currentTab];
	 	var isDateless = tabCache.searchParams.processed.dateLessSearch;

	 	if(CT.subProd == "wg"){
	 		searchFormView.updateWgParams(undefined,"outsideCity")
	 	}else if(CT.subProd == "airBnb"){
	 		CT.subProd = "airBnb";
	 	}else{
	 		searchFormView.updateWgParams(undefined,"withinCity")
	 	}


	 	var $link  = $(this), $arrow = $link.find("i"), $searchForm = $('#SearchForm');

	 	function dateLessCheckinOnFocus(e) {
	 		$(e.currentTarget).tipsy('hide');
	 	}

	 	if($arrow.hasClass("rArrow")){
	 		CT.utils.modifySearch.open($arrow,$link);
	 		if(isDateless) {
	 			$searchForm.find('.checkin_date').bind('focus', dateLessCheckinOnFocus);
	 		}
			//if(CT.subProd == "wg"){
				if($link.closest(".primaryBar").hasClass("stickyPrimaryBar")){
					$link.closest(".primaryBar").removeClass("stickyPrimaryBar")
				}
				window.scrollTo(0, 0)
			//	$(document.body).trigger("sticky_kit:recalc")
			//}
		}else{
			CT.utils.modifySearch.close($arrow,$link);
			if(isDateless) {
				$searchForm.find('.checkin_date').unbind('focus', dateLessCheckinOnFocus).tipsy('hide');
				$('.glassShield').hide().removeAttr('style');
				if(tabCache.checkAvailScroll)
					$(document).scrollTop(tabCache.checkAvailScroll);
			}
		}


	});



  	/**
	 *  Setting up the app with routes
	 */
	 if(window.product != "B2B"){
	 	if(window.location.href.indexOf("getaways") != -1){
	 		var routesPath = '/getaways';
	 	}else{
	 		var routesPath = '/hotels';

	 	}
	 }else{
	 	var routesPath = '/hotels';
	 }
	 routesPath = (window.CT.langUrlPrefix? window.CT.langUrlPrefix:"")+routesPath;

	 var routes = (CT.settings.routes = new Routes(routesPath).add({
		'': ['home', init], //TODO enable in production
		
		'/?:params': ['home', init], //TODO enable in production
		
		'ui=v3': ['home', init], //TODO enable in production

		'/results?:params' : ['search', showSearchResultPage]

	}))

	 
	//>>excludeStart("devCode", pragmas.devCode);
	//.start()  //- App is now started from the config.js file in DEV mode, while index.shtml in prod mode
	window.preCT && window.preCT.destroy();
	//>>excludeEnd("devCode");
})

;
